<template lang="pug">
  b-form-input(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    @blur="handleBlur"
    :formatter="format"
    :lazy-formatter="lazyFormatter"
    :type="type"
    :placeholder="placeholder"
    :disabled="disabled"
    autocomplete="new-password"
  )
</template>

<script>
export default {
  props: {
    form: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function () { return [] }
    },
    value: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: "sm"
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "id"
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
    handleBlur(e) {
      this.$emit("blur", e);
    },
    format(value, event) {
      if(!this.fieldRequired)
        return value;

      if(event.target == null)
        return value;

      if(value == null || value == "")
        return 0;

      return value;
    }
  }
};
</script>


